import * as Flags from "country-flag-icons/react/3x2";

// Bendera dirender dari KODE mata uang memakai SVG bendera yang DIBUNDEL lokal
// (country-flag-icons) — tidak ada permintaan ke situs/jaringan manapun, jadi
// tetap tampil di Windows/Smart TV meski tanpa internet.

// Kode mata uang yang huruf awalnya bukan kode negara ISO-3166 alpha-2.
const ISO_OVERRIDE = {
  EUR: "EU", XAU: null, XAG: null, XPT: null, XDR: null,
};

function isoFromEmoji(emoji) {
  if (!emoji) return null;
  const cps = Array.from(emoji);
  if (cps.length === 2) {
    const a = cps[0].codePointAt(0);
    const b = cps[1].codePointAt(0);
    if (a >= 0x1f1e6 && a <= 0x1f1ff && b >= 0x1f1e6 && b <= 0x1f1ff) {
      return (String.fromCharCode(a - 0x1f1e6 + 65) + String.fromCharCode(b - 0x1f1e6 + 65));
    }
  }
  return null;
}

export function currencyIso(code, emoji) {
  if (code && Object.prototype.hasOwnProperty.call(ISO_OVERRIDE, code)) return ISO_OVERRIDE[code];
  const fromEmoji = isoFromEmoji(emoji);
  if (fromEmoji) return fromEmoji;
  if (code && code.length >= 2) return code.slice(0, 2).toUpperCase();
  return null;
}

export function CurrencyFlag({ code, emoji, className = "", style = {} }) {
  const iso = currencyIso(code, emoji);
  const Flag = iso ? Flags[iso] : null;
  const base = { height: "1em", width: "auto", verticalAlign: "-0.15em", ...style };
  if (Flag) {
    return <Flag title={code || iso} className={`inline-block rounded-[2px] ${className}`} style={base} />;
  }
  return (
    <span className={`inline-block ${className}`} style={style}>
      {emoji || code || "🌐"}
    </span>
  );
}

export default CurrencyFlag;
